import {
  SET_DESTINATION_QUALIFIERS,
  SET_TOWING_SERVICE_ID,
  SEND_SELECTED_DESTINATION,
  UPDATE_DESTINATION_ADDRESS,
  SET_DESTINATION_SELECTED_OPTION,
  GET_DESTINATION_DISTANCE,
  TOGGLE_DESTINATION_ALERT,
} from './types';
import { DestinationState } from 'ts/types/destination.types';
import { createAction, getActionList } from './action-utils';

const actions = {
  setDestinationQualifiers: (result: DestinationState) =>
    createAction(SET_DESTINATION_QUALIFIERS, result),
  setTowingServiceId: (serviceId: string) =>
    createAction(SET_TOWING_SERVICE_ID, serviceId),
  sendSelectedDestination: (choiceId: string) =>
    createAction(SEND_SELECTED_DESTINATION, choiceId),
  updateDestinationAddress: (destinationAddress: any) =>
    createAction(UPDATE_DESTINATION_ADDRESS, destinationAddress),
  setDestinationSelectedOption: (choiceId: string) =>
    createAction(SET_DESTINATION_SELECTED_OPTION, { category: choiceId }),
  getDestinationDistance: () => createAction(GET_DESTINATION_DISTANCE, {}),
  toggleDestinationAlert: (destinationAlertData: any) =>
    createAction(TOGGLE_DESTINATION_ALERT, destinationAlertData),
};

export default actions;

const actionList = getActionList(actions);

export type DestinationActionType = typeof actionList[number];
